import React from "react";
import "./signupNavigation.scss";

const SignupNavigation = ({ currentStep, setStep }) => {
  const steps = [
    { id: 1, label: "Plans" },
    { id: 2, label: "Info" },
    { id: 3, label: "Password" },
    { id: 4, label: "Security" },
    { id: 5, label: "MFA" },
    { id: 6, label: "Verify" },
    { id: 7, label: "Payment" },
  ];

  const handleStepClick = (stepId) => {
    // Prevent navigating back from Payment steps as per security requirement
    if (currentStep >= 7) return;

    // Only allow navigating back to already visited steps
    if (stepId < currentStep) {
      setStep(stepId);
    }
  };

  return (
    <div className="signup-wizard-container">
      {/* Top Stepper Indicator */}
      <div className="signup-stepper">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div
              className={`stepper-item ${currentStep === step.id ? "active" : ""} ${
                currentStep > step.id ? "completed" : ""
              } ${currentStep < step.id || currentStep >= 7 ? "disabled" : ""}`}
              onClick={() => handleStepClick(step.id)}
            >
              <div className="stepper-circle">
                {currentStep > step.id ? (
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                ) : (
                  step.id
                )}
              </div>
              <span className="stepper-label">{step.label}</span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`stepper-connector ${
                  currentStep > step.id ? "completed" : ""
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SignupNavigation;
